<template>
  <section :class="$style.pressContainer">
    <Wrapper :class="$style.inner">
      <PressSidebar
        :class="$style.sidebar"
        :title="sidebar.title"
        :date="sidebar.date"
      />
      <PressArticle :article-data="article" :class="$style.article" />
    </Wrapper>
  </section>
</template>

<script>
import PressSidebar from '../PressSidebar'
import PressArticle from '../PressArticle'

export default {
  name: 'PressContent',

  components: {
    PressSidebar,
    PressArticle,
  },

  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    article() {
      return this.content.article
    },

    sidebar() {
      return this.content.sidebar
    },
  },
}
</script>

<style lang="scss" module>
.pressContainer {
  padding: 0 24px 128px;
}

.inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 80px;

  @include above(medium) {
    flex-direction: row;
    align-items: inherit;
    justify-content: space-between;
  }
}

.sidebar {
  flex-grow: 1;
  min-width: 0;
  max-width: 620px;

  @include above(medium) {
    min-width: 300px;
    max-width: 475px;
    margin-right: 80px;
  }
}

.article {
  flex-grow: 1;
  max-width: 620px;
  margin-top: 80px;

  @include above(medium) {
    margin-top: 0;
  }
}
</style>
